/* eslint-disable no-inner-declarations */
import browserUrl from '../browser-url';

const $phoneworks = $('.Phoneworks-wrap');

if ($phoneworks.length) {
  require.ensure(['knockout', 'knockout-mapping'], () => {
    const ko = require('knockout');
    require('knockout-mapping');

    //
    //
    // Expandables Section
    //
    //

    // init
    $('.expandables')
              .addClass('expandables--js')
              .find('.expandables__window').prepend(
                  '<a href="#" class="arrow left arrow-large-left">Previous</a>',
                  '<a href="#" class="arrow right arrow-large-right">Next</a>');

    // Initially hide left arrow
    $('.arrow.left').hide();

    // vars
    const stage = $('.expandables__window');
    const overflowTrack = $('.expandables__wrap');

    const stageWidth = stage.outerWidth();
    const totalWidth = overflowTrack.outerWidth();

    const totalIcons = $('.expandables__wrap .phonejax-link').length;
    const iconWidth = totalWidth / totalIcons;

    const totalOffset = stageWidth - totalWidth;
    let leftOffset = overflowTrack.position().left;
    let rightOffset = totalOffset - leftOffset;

          // either arrow click
    $('.arrow').click(function click(event) {
      let moveWidth = 0;
      // left click
      if ($(this).hasClass('left')) {
        moveWidth = `+=${iconWidth}`;
      }

      // right click
      if ($(this).hasClass('right')) {
        moveWidth = `-=${iconWidth}`;
      }

      // move track
      $('.expandables__wrap').animate({
        left: moveWidth,
      }, 200, () => {
        leftOffset = overflowTrack.position().left;
        rightOffset = totalOffset - leftOffset;

        if (leftOffset < 0) {
          $('.arrow.left').show();
        } else {
          $('.arrow.left').hide();
        }

        if (rightOffset < 0) {
          $('.arrow.right').show();
        } else {
          $('.arrow.right').hide();
        }
      });

      // return
      event.preventDefault();
    });

    // Snap navigation to top when reached
    const distance = $('.expandables').offset().top;
    const $window = $(window);

    $window.scroll(() => {
      if ($window.scrollTop() >= distance + 1) {
        $('.expandables').addClass('expandables--fixed');
        $('.expandables').addClass('expandables--small');
      } else {
        $('.expandables').removeClass('expandables--fixed');
        $('.expandables').removeClass('expandables--small');
      }
    });

          // Expand view when hovered
    $('.expandables').hover(
      function hoverOn() {
        if ($(this).hasClass('expandables--fixed')) {
          $(this).toggleClass('expandables--small');
        }
      },
      function hoverOff() {
        if ($(this).hasClass('expandables--fixed')) {
          $(this).toggleClass('expandables--small');
        }
      },
    );

    //
    //
    // Main Section
    //
    //

    // DOM Ready
    onLoadFunction();

    // Once YouTube api is ready
    window.onYouTubePlayerAPIReady = function onYouTubePlayerAPIReady() {
      setupPlayers();
    };

    // Include YouTube API
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/player_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    /**
     * Phonejax - site ajaxing
     */

    // Force a trailing /
    if (window.location.pathname === '/phoneworks') {
      window.location = '/phoneworks/';
    }

    if (window.location.hash !== '') {
      window.location = `/phoneworks/${window.location.hash.replace(/#\//, '')}`;
    }

    // We only want knockout to fire if we're on the main page. The inner pages are for google.
    const $phoneworksInfo = $('.family-intro');

    if ($phoneworksInfo.length) {
      const viewModel = {
        Loaded: ko.observable(false),
        Loading: ko.observable(false),
        Tool: ko.observable(),

        getSpriteStyle() {
          const tool = viewModel.Tool();

          if (tool.Sprite.length) {
            return `background-image: url(${tool.Sprite});`;
          }

          return '';
        },
      };

      const $phoneworksTool = $('#product');
      const element = $phoneworksTool[0];
      ko.cleanNode(element);
      ko.setTemplateEngine(new ko.nativeTemplateEngine()); // eslint-disable-line new-cap
      ko.applyBindings(viewModel, element);

      $('.phonejax-link').click(function click() {
        viewModel.Loading(true);

        $('html, body').animate({
          scrollTop: $('#navigation_top').offset().top,
        }, 550);

        const $this = $(this);
        const urlPath = $this.attr('href');

        $.ajax({
          type: 'POST',
          cache: true,
          url: '/api/PhoneWorks/GetTool',
          data: { '': urlPath },
          dataType: 'json',
          success(data) {
            // If the data is null, either the document hasn't been found for some reason,
            // or we've clicked on the phoneworks icon, so clear the model
            if (data == null) {
              // Scroll to top
              $('html, body').animate({
                scrollTop: 0,
              }, 550);

              viewModel.Loaded(false);
              viewModel.Loading(false);
              viewModel.Tool(data);
            } else {
              viewModel.Tool(data);

              viewModel.Loaded(true);
              viewModel.Loading(false);

              onLoadFunction();
              windowHeight();
              filmstripAnimation();
              setupPlayers();
                              // stButtons.locateElements();
              addBullet();
            }

            browserUrl.SetBrowserUrl(urlPath);
          },
          error(jqXHR, textStatus, errorThrown) {
            console.error(textStatus, errorThrown); // eslint-disable-line
          },
          complete() {},
        });

        return false;
      });
    }

          /**
           * SVG Fallbacks for <img src="image.svg" />
           */
    if (!Modernizr.svg) {
      $('img[src*="svg"]').attr('src', function getSrc() {
        return $(this).attr('src').replace('.svg', '.png');
      });
    }

          // Firing animations, cap’n!
    filmstripAnimation();

          // Setup players
    const player = [];

    function setupPlayers() {
      let counter = 1;

      // loop through players and build array
      $('.video-player').each(function each() {
        // set id attr
        $(this).attr('id', `video-${counter}`);

        player[counter] = new YT.Player(`video-${counter}`, {
          events: {
            onReady: onPlayerReady,
          },
        });

        // increment
        counter += 1;
      });
    }

    function onPlayerReady() {
      $('.js-videoPlay').click(function click() {
        const idToPlay = $(this).parent().find('iframe').attr('id')
          .replace('video-', '');
        player[idToPlay].playVideo();
      });

      $('.js-videoPause').click(function click() {
        const idToPause = $(this).parent().find('iframe').attr('id')
          .replace('video-', '');
        player[idToPause].pauseVideo();
      });
    }

    function filmstripAnimation() {
      // Feature test browser for css animations
      if (Modernizr.cssanimations) {
        // Allow css to setup for filmpstrip animation
        $('.filmstrip').addClass('will-animate');

        // Delay to give browser time to get image. @TODO: convert test to
        // ensure asset has downloaded and set timeout fallback if it takes
        // too long.
        setTimeout(() => {
          $('.filmstrip').addClass('init-animation').removeClass('will-animate');
        }, 1000);
      }
    }

    /**
     * Window detect resize
     */
    function windowHeight() {
      const phonejaxWindow = $('.phonejax-window');
      phonejaxWindow.css('min-height', '');

      const currentHeight = phonejaxWindow.height();
      phonejaxWindow.css('min-height', currentHeight);

      $('.expandables__wrap a:first-child').click(() => {
        phonejaxWindow.css('min-height', '');
      });
    }

    function addBullet() {
      $('ul li').each(function each() {
        const $this = $(this);
        if ($this.children('.bullet').length === 0) {
          $this.prepend('<span class="bullet">&nbsp;</div>');

          if ($(this).attr('class') === 'smallli') {
            $('li.smallli span.bullet').remove();
            $(this).prepend('<span class="smallBullet">&nbsp;</div>');
          }
        }
      });
    }

    function onLoadFunction() {
      /**
       * VIDEO PLAYER Toggle
       */
      $('.video-block__play').click(function click(event) {
        /* Act on the event */
        $(this).closest('.video-block').addClass('is-active');
        $(this).closest('.video-block__video').addClass('is-active');
        event.preventDefault();
      });

      $('.video-block__close').click(function click(event) {
        /* Act on the event */
        $(this).closest('.video-block').removeClass('is-active');
        $(this).closest('.video-block__video').removeClass('is-active');
        event.preventDefault();
      });
    }
  });
}
